<template>
    <div class="detailsContainer">
        <van-row>
            <van-col span="16">
                <div>{{ $t('activity.cashBackTotal') + " : " }} <span class="totalValue"> {{formatCurrency(cashbackTotal)}}</span> </div>
            </van-col>
            <van-col span="8">
                <div @click="handleDetailsShow" class="detailIcon">
                    <div class="customText">{{ $t('activity.details') }}</div>
                    <van-icon v-if="!showDetails" name="arrow-down" />
                    <van-icon v-else name="arrow-up" />
                </div>
            </van-col>
        </van-row>
        <div v-if="showDetails">
            <div v-if="isShowTodayCard">
                <CashBackHistoryCard :createTime="todayDayRewards.date" :total-amount="todayDayRewards.totalAmount" 
                    :istodayClaimed="istodayClaimed" :title="title" :day-list="todayDayRewards.rewards" />
            </div>
            <CashBackHistoryCard v-for="(item, index) in setBetList()" :key="index"
                :createTime="item.lossDate ?? item.createTime" :title="title" :day-count="item.dayCount ?? item.day"
                :activity-status="item.status"
                :total-amount="item.totalBetAmount ?? item.rechargeTotal ?? item.totalBetLoss"
                :istodayClaimed="istodayClaimed" :available-amount="item.remainGiftAmount ?? item.availableAmount"
                :day-list="setdayList(item.dayRewards)" />
        </div>

    </div>
</template>
<script lang="ts" setup>
import { PropType, ref, } from 'vue';
import CashBackHistoryCard from './cashBackHistoryCard.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { getBetList, getDayList } from '@/view/components/supportFunction';
import { computed } from 'vue'
const props = defineProps({
    cashbackTotal: {
        type: Number,
        default: () => 0
    },
    betList: {
        type: Array as PropType<any[]>,
        default: () => []
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    type: {
        type: String,
        default: () => ''
    },
    title: String,
    todayDayRewards: {
        type: Object as PropType<any>
    },
    isShowTodayCard: {
        type: Boolean,
        default: () => false
    },
})
const showDetails = ref(false)
const handleDetailsShow = () => {
    showDetails.value = !showDetails.value
}
const hasBetList = computed(() => props.betList && props.betList.length > 0)
const setdayList = (data: any) => getDayList(props.type, data)
const setBetList = () => getBetList(props.betList, props.isShowTodayCard)
</script>
<style scoped>
.detailsContainer {
    padding: 15px 25px;
    color: rgba(255, 255, 255, .6);
    font-weight: bold;
    font-size: 15px;
}

.totalValue{
    color: #FFF;
}

.detailIcon {
    display: flex;
    flex-direction: row;
    justify-content: right;
    color: rgba(255, 255, 255, .6);
    cursor: pointer;
    margin-top: 5px
}

.customText {
    padding-right: 5px;
}

.detailIcon>>>.van-icon {
    /* background: #FFF; */
    font-size: 9px;
    padding: 2px;
    display: flex;
    align-items: center;
}

@media (max-width: 360px) {
    .detailsContainer{
        font-size: 13px;
    }
} 
</style>
